import africa from "./africa.json";
import world from "./world.json";
import { CountryList } from "@/types/country.types";

const countryList: CountryList = {
  africa: africa,
  world: world,
};

export default countryList;
